import React from 'react';
import './Recommendations.css';
import { TdsBlock } from '@scania/tegel-react';
import MainHeader from '../../../components/atoms/Typography/MainHeader';
import RelocationIcon from '../../../components/atoms/SvgIcons/RelocationIcon';
import RightsizingIcon from '../../../components/atoms/SvgIcons/RightsizingIcon';
import ReArchitectureIcon from '../../../components/atoms/SvgIcons/ReArchitectureIcon';

function RecommendationsThreeRs() {
  return (
    <TdsBlock>
      <MainHeader>The Three Rs</MainHeader>
      <div className={'tds-container'}>
        <div className={'tds-row'}>
          <div className={'tds-col'}>
            <div className={'tds-u-flex tds-u-flex-dir-col tds-u-align-center'}>
              <span className={'recommendations-intro-icon-image'}>
                <RelocationIcon height={'65'} width={'65'} />
              </span>
              <p>Relocation</p>
            </div>
          </div>
          <div className={'tds-col'}>
            <div className={'tds-u-flex tds-u-flex-dir-col tds-u-align-center'}>
              <span className={'recommendations-intro-icon-image'}>
                <RightsizingIcon height={'65'} width={'65'} />
              </span>
              <p>Rightsizing</p>
            </div>
          </div>
          <div className={'tds-col'}>
            <div className={'tds-u-flex tds-u-flex-dir-col tds-u-align-center'}>
              <span className={'recommendations-intro-icon-image'}>
                <ReArchitectureIcon height={'65'} width={'65'} />
              </span>
              <p>Re-architecting</p>
            </div>
          </div>
        </div>
      </div>
    </TdsBlock>
  );
}

export default RecommendationsThreeRs;
